import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import {
  OrganizationService,
  PdfViewerService,
  TaskService,
} from '../../services';
import { request } from 'http';
import { tap } from 'rxjs/operators';
import { AppFilter } from '@app/shared/models';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ConfirmModal, RejectModal } from '@app/shared/modals';

interface IFieldChangeModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-field-registration-details-verify',
  templateUrl: './registration-details-modal.html',
  styleUrls: ['./registration-details-modal.scss'],
})
export class RegistrationDetailsVerifyModalComponent
  implements OnInit, OnDestroy
{
  searchable: boolean = true;
  baseUrl: string = environment.API_SERVER;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  roleForm: FormGroup;
  audit;
  request;
  filter: AppFilter;
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  history;
  toValue;
  fromValue;
  type;
  organizationData;
  organizationParams: AppFilter;
  companies;
  tinNumber;
  documentsType;
  documentType;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'companyName',
        op: 'cn',
        data: '',
      },
    ],
  };
  open: boolean = false;
  countries;
  organization;
  states;
  origin;
  nationality;
  companyOrg;
  groupedDocuments: any[] = [];
  personnelStructures: any[] = [];
  companyOrganization;
  shareholderDisplayInfo = [
    {
      name: 'Shareholder type',
      key: 'shareholderType',
      default: '---',
      group: 'shareholder_information',
    },
    {
      name: 'Company Name',
      key: 'companyName',
      default: '---',
      group: 'shareholder_information',
    },
    {
      name: 'Company Registration Number',
      key: 'companyRegNumber',
      default: '---',
      group: 'shareholder_information',
    },
    {
      name: 'Allocated Shares',
      key: 'share',
      default: '0',
      group: 'shareholder_information',
      outside: true,
      func: (data) => {
        return (data.shareholding * this.companyOrg.totalShareCapital) / 100;
      },
    },
    {
      name: 'Total Share Capital',
      key: 'shareholding',
      default: '0',
      group: 'shareholder_information',
      outside: true,
      func: (data) => {
        return this.companyOrg.totalShareCapital;
      },
    },
    {
      name: 'Share Capital Percentage',
      key: 'shareholding',
      default: '0',
      group: 'shareholder_information',
      suffix: '%',
    },

    {
      name: 'First Name',
      key: 'firstName',
      default: '---',
      group: 'company_representative_information',
    },
    {
      name: 'Last Name',
      key: 'lastName',
      default: '---',
      group: 'company_representative_information',
    },
    {
      name: 'Middle Name',
      key: 'middleName',
      default: '---',
      group: 'company_representative_information',
    },
    {
      name: 'Gender',
      key: 'gender',
      default: '---',
      group: 'company_representative_information',
    },
    {
      name: 'Address',
      key: 'address',
      default: '---',
      group: 'company_representative_information',
    },

    {
      name: 'Nationality',
      key: 'nationalityId',
      default: '---',
      group: 'nationality',
      type: 'country',
    },
    {
      name: 'Country of Origin',
      key: 'countryOfOriginId',
      default: '---',
      group: 'nationality',
      type: 'country',
    },
    {
      name: 'National ID Number',
      key: 'nationalIdNumber',
      default: '---',
      group: 'nationality',
    },
    {
      name: 'NIN Slip',
      key: 'ninSlip',
      default: '---',
      group: 'nationality',
      type: 'file',
    },

    {
      name: 'Email',
      key: 'email',
      default: '---',
      group: 'contact_information',
    },
    {
      name: 'Phone Number',
      key: 'phoneNumber',
      default: '---',
      group: 'contact_information',
    },
  ];
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IFieldChangeModalContext, void, void>,
    private taskService: TaskService,
    private modalService: SuiModalService,
    private router: Router,
    private organizationSvc: OrganizationService,
    private pdfViewerService: PdfViewerService
  ) {
    this.request = modal.context.data;
    console.log(this.request, 'request');
    this.personnelStructures = this.request.personnelStructures;
    this.companyOrganization =
      this.request.changeRequest.organization.jpaContractor;
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.getCountryOrigin(this.toValue);

    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.organizationParams = new AppFilter({
      sidx: 'dateCreated',
      sord: 'desc',
    });
    this.searchFilter.rules[0].data =
      this.request.changeRequest.organization.jpaContractor.companyName;
    this.organizationParams.filters = JSON.stringify(this.searchFilter);
    this.organizationData =
      this.request.changeRequest.organization.jpaContractor;
    console.log(this.organizationData);
    this.getPage(1);
    // this.getDocuments();
    // this.updateRequest();
    this.getPageData(1);
    this.getOrgPage(1);
  }
  viewDocument(data) {
    this.pdfViewerService.viewPdf(data);
  }
  viewDocumentPath(path: string, name: string): void {
    this.pdfViewerService.viewPdf({
      documentPath: path,
      documentName: name,
    });
  }
  getShareholderDisplayInfo(data) {
    // console.log(data, 'data');

    if (
      data.shareholderType === 'Individual' ||
      (!data.companyName && !data.companyRegNumber)
    ) {
      const info = this.shareholderDisplayInfo.filter(
        (item) => !item.key.includes('company')
      );
      return info;
    }
    return this.shareholderDisplayInfo;
  }

  getData(data, item) {
    if (data[item.key]) {
      if (item.type === 'country') {
        return this.filterResult(data[item.key]);
      }
      return data[item.key];
    }

    if (item.key2) {
      // console.log(data, item.key2)
      if (data[item.key2]) {
        if (item.type === 'country') {
          return this.filterResult(data[item.key2]);
        }
        return data[item.key2];
      }
    }
    return item.default;
  }

  getOptionTypes(data) {
    let filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10000,
      sord: 'desc',
    });
    this.organizationSvc.getDocumentType({ params: filter }).subscribe(
      (res: any) => {
        // this.optionLoading = false;
        this.documentsType = res['rows'];
        let result = this.documentsType.filter((item) => {
          return item.documentTypeId === data;
        });
        this.documentType = result[0]?.documentTypeName;
      },
      (error) => {}
    );
  }
  getOrgPage(page) {
    // set the page number from the caller
    this.organizationParams.page = page;
    this.pending = true;
    this.error = null;
    this.taskService
      .getALLCompany({
        organizationId: this.organization.organizationId,
        params: this.organizationParams,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.organizationParams.rows;
          this.companyOrg = res['rows'][0];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getCountry(data) {
    let result = this.origin.filter((item) => {
      return item.countryCode === data.countryOfRegistration;
    });
    this.countries = result[0];
    // console.log(this.countries[0]);
  }
  dataToBeSent() {
    console.log(this.tinNumber);
    let data;
    if (this.type === 'COMPANY_NAME' && this.companies.approvedName) {
      data = {
        companyName: this.companies.approvedName,
        actionType: this.request.changeRequest.actionType,
        changeRequestType: this.request.changeRequest.changeRequestType,
      };
      // this.updateRequest(data);
      this.save('APPROVED');
    } else if (
      this.type === 'TIN' &&
      this.tinNumber !== 'No Record from FIRS'
    ) {
      data = {
        tinNumber: this.tinNumber,
        firsRecord: this.toValue.firsRecord,
        actionType: this.request.changeRequest.actionType,
        changeRequestType: this.request.changeRequest.changeRequestType,
      };
      // this.updateRequest(data);
      this.save('APPROVED');
    } else if (this.type === 'OTHER_TIN') {
      data = {
        tinNumber: this.tinNumber,
        firsRecord: this.toValue.firsRecord,
        actionType: this.request.changeRequest.actionType,
        changeRequestType: this.request.changeRequest.changeRequestType,
      };
      // this.updateRequest(data);
      this.save('APPROVED');
    } else if (this.type === 'RC_NUMBER' && this.companies.rcNumber) {
      data = {
        rcNumber: this.companies.rcNumber,
        companyType: this.companyOrg.contractor.actualCompanyType.optionId,
        ownershipType: this.companyOrg.contractor.ownershipType.optionId,
        dateOfRegistration: this.companies.registrationDate,
      };
      // this.updateRequest(data);
      this.save('APPROVED');
    } else {
      this.save('APPROVED');
    }
  }
  filterEquip(data) {
    // organizationId;
    if (data.key === 'equipTypeId') {
      return data.value.replaceAll('_', ' ');
    } else if (data.key === 'organizationId') {
      delete data.value;
    } else {
      return data.value;
    }
  }
  // acceptUpdate() {
  //   if (this.type === 'COMPANY_NAME' && this.companies.approvedName) {
  //     this.updateRequest();
  //   }
  // }
  getCountryOrigin(data) {
    this.organizationSvc
      .getCountries({ organizationId: this.organization.organizationId })
      .subscribe((res) => {
        this.origin = res['rows'];
        if (this.personnelStructures.includes(this.request.changeRequestType)) {
          this.toValue = JSON.parse(
            this.request.changeRequest.changes
              ? this.request.changeRequest.changes
              : this.request.changeRequest.toValue
          );
        } else {
          this.toValue = JSON.parse(this.request.changeRequest.toValue);
        }
        this.fromValue = JSON.parse(this.request.changeRequest.fromValue);
        if (this.personnelStructures.includes(this.request.changeRequestType)) {
          this.toValue = JSON.parse(
            this.request.changeRequest.changes
              ? this.request.changeRequest.changes
              : this.request.changeRequest.toValue
          );
        } else {
          this.toValue = JSON.parse(this.request.changeRequest.toValue);
        }
        if (
          // this.request.changeRequestType == 'DIRECTOR_STRUCTURE' ||
          // this.request.changeRequestType == 'SHAREHOLDER_STRUCTURE'
          this.personnelStructures.includes(this.request.changeRequestType)
        ) {
          let seen2 = new Set();
          this.fromValue = this.fromValue.filter((obj) => {
            if (obj.actionType === 'ADD') {
              return true;
            } else if (seen2.has(obj.organizationOwnershipId)) {
              return false;
            } else {
              seen2.add(obj.organizationOwnershipId);
              return true;
            }
          });
          this.toValue.map((item) => {
            if (item.actionType === 'NONE') {
              this.fromValue.push(item);
            } else if (item.actionType) {
            } else {
              this.fromValue.push(item);
            }
          });
          const seenNationalIds = new Set();
          this.fromValue = this.fromValue.filter((item) => {
            if (!seenNationalIds.has(item.nationalIdNumber)) {
              seenNationalIds.add(item.nationalIdNumber);
              return true;
            }
            return false;
          });
        }
        this.type = this.request.changeRequestType;
        console.log(this.toValue, this.type, 'totovalue');
        if (this.request.changeRequestType === 'OFFICIAL_DOCUMENT') {
          this.getOptionTypes(this.toValue.documentTypeId);
        }
        if (this.toValue.organizationOwnershipTypeId) {
          delete this.toValue.organizationOwnershipTypeId;
        }
        if (this.toValue.organizationId === '') {
          delete this.toValue.organizationId;
        }
        if (
          this.toValue.organizationOwnershipId ||
          this.toValue.organizationOwnershipId === ''
        ) {
          delete this.toValue.organizationOwnershipId;
        }
        if (this.request.changeRequestType === 'ADDRESS') {
          this.getCountry(this.toValue);
          this.getStates(this.toValue);
        }
        if (this.request.changeRequestType === 'TIN') {
          this.getTinData(this.toValue);
        }
        if (
          this.toValue.organizationOwnershipId ||
          this.toValue.organizationOwnershipId === ''
        ) {
          delete this.toValue.organizationOwnershipId;
        }
        if (this.personnelStructures.includes(this.request.changeRequestType)) {
          this.documents = this.toValue[0].documents;
        } else {
          if (this.toValue.documents) {
            this.documents = this.toValue.documents;
          } else if (this.toValue.document) {
            this.documents = [this.toValue.document];
          } else {
            this.documents = [];
          }
        }
        // this.documents = this.toValue.documents;
        if (this.documents && this.documents.length > 0) {
          this.groupData(this.documents);
        } else {
          this.getDocuments();
        }
      });
  }
  groupData(data) {
    if (this.request.changeRequestType === 'OFFICIAL_DOCUMENT') {
      const groupedObjects = data.reduce((result, obj) => {
        const key = obj.documentTypeName;
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(obj);
        return result;
      }, {});
      this.groupedDocuments = Object.entries(groupedObjects).map(
        ([key, value]) => ({ key, value })
      );
    } else {
      data.map((item) => {
        if (!item.documentTypeId.documentTypeName) {
          item.documentTypeId.documentTypeName = item.documentName;
        }
      });
      const groupedObjects = data.reduce((result, obj) => {
        const key = obj.documentTypeId.documentTypeId
          ? obj.documentTypeId.documentTypeName
          : obj.documentTypeName;
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(obj);
        return result;
      }, {});
      this.groupedDocuments = Object.entries(groupedObjects).map(
        ([key, value]) => ({ key, value })
      );
    }
  }
  getCountryNational(data) {
    this.organizationSvc
      .getCountries({ organizationId: this.organization.organizationId })
      .subscribe((res) => {
        this.nationality = res['rows'];
        this.nationality = this.nationality.filter((item) => {
          return item.countryCode === data.nationalityId;
        });
        this.nationality = this.nationality[0];
      });
  }
  getStates(data) {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
      // this.states = this.states.filter((item) => {
      //   return item.stateId === data.headOfficeAddressState
      //     ? data.headOfficeAddressState
      //     : data.headOfficeAddressStateId;
      // });
      // this.states = this.states[0];
    });
  }
  showValue(data) {
    if (data.key === 'countryOfRegistration') {
      let result = this.origin?.filter((item) => {
        return item.countryCode === data.value;
      });
      if (result) {
        return result[0]?.countryName;
      }
    } else if (
      data.key === 'headOfficeAddressState' ||
      data.key === 'headOfficeAddressStateId'
    ) {
      let result = this.states?.filter((item) => {
        return item.stateId === data.value;
      });
      if (result) {
        return result[0]?.stateName;
      }
    } else if (data.key === 'documents') {
      return '';
    } else {
      return data.value;
    }
  }
  getType(type: string) {
    return type.replace(/_.*/g, '');
  }
  showValueDirector(data) {
    if (data.key === 'countryOfOriginId') {
      return this.filterResult(data.value);
    } else if (data.key === 'nationalityId') {
      return this.filterResult(data.value);
    } else if (data.key === 'organizationOwnershipId') {
      return '';
    } else if (data.key === 'organizationOwnershipTypeId') {
      return '';
    } else if (data.key === 'actionType') {
      return '';
    } else if (data.key === 'photographDocumentId') {
      return '';
    } else if (data.key === 'photographDocumentPath') {
      return '';
    } else if (
      data.key === 'shareholding' &&
      this.type !== 'SHAREHOLDER_STRUCTURE'
    ) {
      return '';
    } else if (data.key === 'ownershipTypeName') {
      return '';
    } else if (data.key === 'share') {
      return '';
    } else if (data.key === 'ownershipTypeIdName') {
      return '';
    } else if (data.key === 'documents') {
      return '';
    } else if (data.key === 'shareholderType') {
      return '';
    } else if (data.key === 'createdBy') {
      return '';
    } else if (data.key === 'dateCreated') {
      return '';
    } else if (data.key === 'modifiedBy') {
      return '';
    } else if (data.key === 'dateModified') {
      return '';
    } else if (data.key === 'organizationId') {
      return '';
    } else if (data.key === 'deleted') {
      return '';
    } else if (data.key === 'countryOfOriginName') {
      return '';
    } else if (data.key === 'nationalityName') {
      return '';
    } else if (data.key === 'companyName' && data.value === 'null') {
      return '';
    } else if (data.key === 'companyRegNumber' && data.value === 'null') {
      return '';
    } else {
      return data.value;
    }
  }
  isFieldValid(field: string) {
    return (
      (!this.roleForm.get(field).valid && this.roleForm.get(field).touched) ||
      (this.roleForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  getTinData(data) {
    this.pending = true;
    this.error = null;
    if (data?.tinNumber && data?.firsRecord?.TaxPayerName) {
      this.tinNumber = data.tinNumber;
      this.pending = false;
    } else {
      this.pending = false;
      this.tinNumber = 'No Record from FIRS';
    }
    // this.taskService
    //   .getTinData({
    //     tinNumber: data.tinNumber,
    //   })
    //   .subscribe(
    //     (res: any) => {
    //       this.tinNumber = res.TIN;
    //       // console.log(this.tinNumber);
    //       this.pending = false;
    //     },
    //     (error) => {
    //       this.pending = false;
    //       this.tinNumber = 'No Record from FIRS';
    //     }
    //   );
  }
  getPageData(page) {
    // set the page number from the caller
    this.organizationParams.page = page;
    this.pending = true;
    this.error = null;
    const companyTypeId = this.request.changeRequest.organization.jpaContractor
      .actualCompanyType
      ? this.request.changeRequest.organization?.jpaContractor.actualCompanyType
          .optionId
      : this.request.changeRequest.organization?.jpaContractor.companyTypeId
      ? this.request.changeRequest.organization?.jpaContractor.companyTypeId
          .optionId
      : '';
    this.taskService
      .getCacData({
        companyTypeId: companyTypeId,
        rcNumber:
          this.request.changeRequest.organization.jpaContractor?.rcNumber,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.companies = res;
          console.log(this.companies);
        },
        (error) => {
          this.pending = false;
          this.companies = 'no record';
        }
      );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  rename(data) {
    if (data === 'companyType') {
      return 'COMPANY TYPE';
    } else if (data === 'dateOfRegistration') {
      return 'DATE OF REGISTRATION';
    } else if (data === 'ownershipType') {
      return 'OWNERSHIP TYPE';
    } else if (data === 'rcNumber') {
      return 'RC NUMBER';
    }
  }
  value(data) {
    if (data.key === 'companyType') {
      return data.value.split('_actual')[0].replaceAll('_', ' ');
    } else if (data.key === 'dateOfRegistration') {
      return data.value;
    } else if (data.key === 'ownershipType') {
      return data.value.replaceAll('_', ' ');
    } else if (data.key === 'rcNumber') {
      return data.value;
    }
  }
  equipmentValue(data) {
    if (data === 'equipModelNumber') {
      return 'EQUIPMENT MODEL NUMBER';
    } else if (data === 'equipName') {
      return 'EQUIPMENT NAME';
    } else if (data === 'equipTypeId') {
      return 'EQUIPMENT TYPE';
    } else if (data === 'yearOfManufacture') {
      return 'YEAR OF MANUFACTURE';
    } else if (data === 'manufacturerName') {
      return 'MANUFACTURER NAME';
    }
  }
  addressValue(data) {
    if (data === 'countryOfRegistration') {
      return 'COUNTRY';
    } else if (
      data === 'headOfficeAddressState' ||
      data === 'headOfficeAddressStateId'
    ) {
      return 'STATE';
    } else if (data === 'headOfficeAddressCity') {
      return 'CITY';
    } else if (data === 'headOfficeAddressStreet') {
      return 'STREET';
    } else if (data === 'headOfficeAddressZip') {
      return 'ZIP';
    }
  }
  directorValue(data, exist, fullData) {
    if (data === 'countryOfOriginId') {
      return 'COUNTRY OF ORIGIN';
    } else if (data === 'firstName') {
      return 'FIRST NAME';
    } else if (data === 'gender') {
      return 'GENDER';
    } else if (data === 'lastName') {
      return 'LAST NAME';
    } else if (data === 'middleName') {
      return 'MIDDLE NAME';
    } else if (data === 'nationalIdNumber') {
      return 'NATIONAL ID NUMBER';
    } else if (data === 'nationalityId') {
      return 'NATIONALITY';
    } else if (data === 'address') {
      return 'ADDRESS';
    } else if (data === 'email') {
      return 'EMAIL ADDRESS';
    } else if (
      data === 'shareholding' &&
      this.type === 'SHAREHOLDER_STRUCTURE'
    ) {
      return 'SHAREHOLDING AMOUNT';
    } else if (data === 'ownershipTypeName') {
      return '';
    } else if (data === 'ownershipTypeIdName') {
      return '';
    } else if (data === 'phoneNumber') {
      return 'PHONE NUMBER';
    } else if (data === 'organizationOwnershipId') {
      return '';
    } else if (data === 'organizationOwnershipTypeId') {
      return '';
    } else if (data === 'actionType') {
      return '';
    } else if (data === 'photographDOcumentId') {
      return '';
    } else if (data === 'share') {
      return '';
    } else if (data === 'companyName' && exist && fullData.value !== 'null') {
      return 'Company Name';
    } else if (
      data === 'companyRegNumber' &&
      exist &&
      fullData.value !== 'null'
    ) {
      return 'Company Registration Name';
    } else if (data === 'companyName' && !exist) {
      return '';
    } else if (data === 'companyRegNumber' && !exist) {
      return '';
    } else if (data === 'createdBy') {
      return '';
    } else if (data === 'dateCreated') {
      return '';
    } else if (data === 'modifiedBy') {
      return '';
    } else if (data === 'dateModified') {
      return '';
    } else if (data === 'organizationId') {
      return '';
    } else if (data === 'deleted') {
      return '';
    } else if (data === 'countryOfOriginName') {
      return '';
    } else if (data === 'nationalityName') {
      return '';
    }
  }

  returnPercent(data) {
    if (data) {
      return `${data}%`;
    } else if (data === 0) {
      return '0%';
    }
  }
  shareHolderValue(data) {
    if (data === 'countryOfOriginId') {
      return 'COUNTRY OF ORIGIN';
    } else if (data === 'firstName') {
      return 'FIRST NAME';
    } else if (data === 'gender') {
      return 'GENDER';
    } else if (data === 'lastName') {
      return 'LAST NAME';
    } else if (data === 'middleName') {
      return 'MIDDLE NAME';
    } else if (data === 'nationalIdNumber') {
      return 'NATIONAL ID NUMBER';
    } else if (data === 'nationalityId') {
      return 'NATIONALITY';
    } else if (data === 'address') {
      return 'ADDRESS';
    } else if (data === 'email') {
      return 'EMAIL ADDRESS';
    } else if (data === 'shareholding') {
      return 'SHAREHOLDING AMOUNT';
    } else if (data === 'ownershipTypeName') {
      return '';
    } else if (data === 'phoneNumber') {
      return 'PHONE NUMBER';
    } else if (data === 'organizationOwnershipId') {
      return '';
    } else if (data === 'organizationOwnershipTypeId') {
      return '';
    } else if (data.key === 'actionType') {
      return '';
    } else if (data.key === 'photographDOcumentId') {
      return '';
    } else if (data.key === 'share') {
      return '';
    }
  }
  filterResult(data) {
    let result = this.origin.filter((item) => {
      return item.countryCode === data;
    });
    return result[0]?.countryName;
  }
  contactValue(data) {
    if (data === 'companyContactAlternativeEmail') {
      return 'ALTERNATIVE EMAIL';
    } else if (data === 'companyContactEmail') {
      return 'EMAIL';
    } else if (data === 'companyContactPhone1') {
      return 'PHONE NUMBER';
    } else if (data === 'website') {
      return 'WEBSITE';
    }
  }
  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  getPage(page) {
    this.pending = true;
    (this.filter['organizationId'] =
      this.request.workflowGroups?.collaboratorId.collaboratorId),
      this.taskService
        .getRequestHistory({
          params: this.filter,
          changeRequestType: this.request.changeRequestType,
        })
        .pipe(
          tap((res) => {
            this.totalItems = +res['records'];
            this.currentPage = page;
            this.rows = this.filter.rows;
          })
        )
        .subscribe(
          (res) => {
            this.pending = false;
            this.history = res['rows'];
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
  }
  documents;
  getDocuments() {
    this.pending = true;
    this.taskService
      .getRequestDocument({
        changeRequestType: this.request.changeRequest.changeRequestId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.documents = res;
          this.groupData(this.documents);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  updateRequest(data) {
    this.pending = true;
    let body = {
      toValue: JSON.stringify(data),
      actionType: this.request.changeRequest.actionType,
      changeRequestType: this.request.changeRequest.changeRequestType,
    };
    this.taskService
      .updateValueRequest({
        changeRequestId: this.request.changeRequest.changeRequestId,
        body: body,
      })
      .subscribe(
        (res) => {
          setTimeout(() => {
            this.save('APPROVED');
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  save(data, reason?) {
    this.pending = true;
    let body = {
      approvalMonitoringId: this.request.approvalMonitoringId,
      status: data,
      remark: reason ? reason : null,
    };
    this.taskService.acceptOrRejectUpdate({ body: body }).subscribe(
      (res) => {
        this.pending = false;
        this.success = 'Request Update Successful';
        setTimeout(() => {
          this.modal.approve(null);
          // data === 'APPROVED'
          //   ? this.router.navigateByUrl('/admin/tasks/list/approved-approval')
          //   : this.router.navigateByUrl('/admin/tasks/list/rejected-approval');
        }, 2000);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  verifyDetails(data) {
    this.modalService
      .open(
        new RegistrationDetailsVerifyModal(
          'Change Registration Details',
          data,
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  notifyUser(type) {
    if (this.type === 'COMPANY_NAME' || this.type === 'RC_NUMBER') {
      if (this.companies === 'no record') {
        this.error =
          "Changes can't be made because Your Record are not verified from CAC ";
      } else {
        this.verify(type);
      }
    } else if (this.type === 'TIN') {
      if (
        this.tinNumber === 'No Record from FIRS' ||
        this.tinNumber?.trim() !== this.toValue.tinNumber?.trim()
      ) {
        this.error =
          "Changes can't be made because Your Record are not verified from FIRS";
      } else {
        this.verify(type);
      }
    } else {
      this.verify(type);
    }
  }

  verify(type) {
    if (type === 'Decline') {
      this.reject('Decline');
    }
    if (type === 'Accept') {
      this.accept('Accept');
    }
  }
  accept(type) {
    this.modalService
      .open(
        new ConfirmModal(
          `${type} Update?`,
          `Are you sure you want to ${type} Update?`,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.dataToBeSent();
      })
      .onDeny(() => {});
  }
  reject(type) {
    this.modalService
      .open(
        new RejectModal(
          `${type} Update?`,
          `Are you sure you want to ${type} Update?`,
          ModalSize.Tiny
        )
      )
      .onApprove((data) => {
        if (data) {
          console.log(data, 'reason');
          this.save('REJECTED', data);
        }
      })
      .onDeny(() => {});
  }
  isButtonDisabled(): boolean {
    if (this.pending) {
      return true;
    }
    if (this.type === 'TIN' && this.documents?.length > 0) {
      return false;
    }
    if (this.type === 'TIN' && this.tinNumber === 'No Record from FIRS') {
      return true;
    }
    if (this.type === 'TIN' && !this.getIfTinMatch()) {
      return true;
    }
    return false;
  }
  getIfTinMatch() {
    return this.tinNumber?.trim() === this.toValue.tinNumber?.trim();
  }
}

export class RegistrationDetailsVerifyModal extends ComponentModalConfig<
  IFieldChangeModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(RegistrationDetailsVerifyModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
